import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import { ServiceForm } from './../forms'
import { Dashboard } from './../layouts'

const styles = theme => ({
    //
})

class ServiceNew extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            title: 'Үйлчилгээ'
        }
    }

    render() {
        const { title } = this.state
        return (
            <Dashboard title={title}>
                <ServiceForm 
                    path="services"
                    method="post"
                    message="Амжилттай нэмэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(ServiceNew)
